module.exports = __webpack_public_path__ + "img/exam-logo.746574bb.png";